import React, { Component } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Form from './Form';
import imageTrellisLogo from '../assets/images/trellisfull.svg';
import media from '../styles/media';

class Footer extends Component {
  render() {
    return (
      <Root id="Contact">
        <Form />
        <TextContainer>
          <h2>Get in touch</h2>
          <h4>Trellis Properties</h4>
          <p>Unit 207 - 12639 80th Ave </p>
          <p>Surrey, BC</p>
          <p>V3W 3A6</p>
          <a href="mailto:info@trellisproperties.ca">
            <h3>info@trellisproperties.ca</h3>
          </a>
          <TrellisLogo src={imageTrellisLogo} />
          <LinksContainer>
            <Link to="/terms">
              <h4>Terms of Use </h4>
            </Link>
            <h4>|</h4>
            <Link to="/policy">
              <h4>Privacy Policy</h4>
            </Link>
          </LinksContainer>
        </TextContainer>
        <Copyright>
          Copyright © TRELLIS PROPERTIES. All rights reserved.
        </Copyright>
      </Root>
    );
  }
}

export default Footer;

const Copyright = styled.h4`
  @media (min-width: ${media.md}) {
    display: none;
  }
  display: block;
  width: 340px;
  text-align: center;
  margin: 0 auto;
  margin-bottom: 31px;
`;

const LinksContainer = styled.div`
  @media (min-width: ${media.md}) {
    margin-top: 230px;
  }
  position: relative;
  width: 224px;
  justify-content: space-between;
  display: flex;
  margin-top: 30px;
  h4 {
    opacity: 0.33;
  }
`;

const TrellisLogo = styled.img`
  width: 157px;
  height: 157px;
  margin-top: 30px;
`;

const Root = styled.div`
  @media (min-width: ${media.md}) {
    display: flex;
    height: 900px;
    div:nth-of-type(1) {
      order: 2;
    }
    button {
      margin-left: 0px;
      margin-top: 20px;
    }
  }
  h2 {
    font-size: 24px;
  }
`;

const TextContainer = styled.div`
  @media (min-width: ${media.md}) {
    width: 20%;
    align-items: flex-start;
    margin-left: 10%;
    margin-top: 135px;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 67px;
  h2 {
    font-size: 24px;
    margin-bottom: 22px;
  }
  h4 {
    margin-bottom: 24px;
  }
  h3 {
    font-family: 'Source Sans Pro Regular';
    font-size: 18px;
    color: #f57f29;
    letter-spacing: 0;
    text-align: center;
    line-height: 27px;
    font-weight: lighter;
  }
  p:nth-child(5) {
    margin-bottom: 30px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Footer.js